import { render, staticRenderFns } from "./MultipleA.vue?vue&type=template&id=fb12772c&scoped=true&"
import script from "./MultipleA.vue?vue&type=script&lang=js&"
export * from "./MultipleA.vue?vue&type=script&lang=js&"
import style0 from "./MultipleA.vue?vue&type=style&index=0&id=fb12772c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb12772c",
  null
  
)

export default component.exports